import React from 'react';
import { Link } from 'react-router-dom'
import { Dropdown, Button, Card, Avatar, message } from 'antd'
import { MdClearAll, MdExitToApp } from 'react-icons/md';
import { Breadcrumb, BreadcrumbItem, ListGroup, ListGroupItem, Nav, Navbar, NavItem, NavLink } from 'reactstrap';
import { allPaths } from '../../utils/breadcrumbs'
import { config } from '../../configs';
import bn from 'utils/bemnames';
import adminAvatar from '../../assets/images/avatar/admin.png';
import editorAvatar from '../../assets/images/avatar/editor.png';
import DM from '../../utils/DataManagement';

const { Meta } = Card;
const bem = bn.create('header');
const configURL = config.server_url;

class Header extends React.Component {
  state = {
    isNotificationConfirmed: false,
    loggedInUser: undefined
  };

  componentDidMount() {
    this.loadToLoggedInUser()
  }

  loadToLoggedInUser = () => {
    const rawUser = DM.getLoggedInUser() || {};

    const user = {
      ...rawUser,
      avatar:
        rawUser.role === "admin"
          ? adminAvatar
          : rawUser.role === "editor"
          ? editorAvatar
          : undefined,
      displayRole: this.capitalizeFirstLetter(rawUser.role),
    };

    this.setState({ loggedInUser: user });
  };

  capitalizeFirstLetter = (string) => {           
    if (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
      return "";
  }

  logout = async () => {
    const accessToken = localStorage.getItem("access_token");

    try {
      if (accessToken) {
        await fetch(`${configURL}/users/logout`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: "application/json",
          },
          credentials: "same-origin",
        });
      }
    } catch (err) {
      console.error("Logout request failed:", err);
    } finally {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("token_type");
      localStorage.removeItem("access_token_expires_at");
      localStorage.removeItem("refresh_token_expires_at");
      localStorage.removeItem("username");
      localStorage.removeItem("name");
      localStorage.removeItem("role");
      DM.clearLoggedInUser();
      message.info("Çıkış yapıldı!");
      window.location.replace("/login");
    }
  };

  handleSidebarControlButton = event => {
    event.preventDefault();
    event.stopPropagation();

    document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
  };

  render() {
    const { pathname } = this.props;
    const matched = allPaths.filter((i) => i.path == pathname)[0];
    const crumb = matched ? matched.breadcrumb : [];
    const { loggedInUser } = this.state;
    const avatar = loggedInUser && loggedInUser.avatar;
    
    const menu = (
      <ListGroup >
        <ListGroupItem action className="border-light">
          <Card
            style={{ width: 300, borderRadius: 5, color: 'black' }}>
            <Meta
              avatar={<Avatar src={avatar} />}
              title={loggedInUser ? loggedInUser.name : ""}
              description={loggedInUser ? loggedInUser.displayRole : ""}
            />

            <Link to="/login" onClick={() => this.logout()}>
              <Button
                type="primary"
                danger
                block
                onClick={this.logout}
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: 15,
                }}
              >
                <MdExitToApp size={20} style={{ marginRight: 5, color: "black" }} />
                Çıkış
                </Button>
            </Link>
          </Card>
        </ListGroupItem>
      </ListGroup>
    );

    return (
        <Navbar light expand className={bem.b('bg-white')} style={{ marginTop: 5 }}>
          <Nav navbar className="mr-2">
            <Button onClick={this.handleSidebarControlButton} >
              <MdClearAll size={25} />
            </Button>
          </Nav>

          <Nav style={{ marginLeft: 5, marginTop: 16.5 }}>
            <Breadcrumb className={bem.e("breadcrumb")}>
              {crumb.length &&
                crumb.map(({ name, active, link }, index) => (
                  <BreadcrumbItem key={index} active={active}>
                    {link ? <Link to={link}>{name}</Link> : <span>{name}</span>}
                  </BreadcrumbItem>
                ))}
            </Breadcrumb>
          </Nav>

          <Nav navbar className={bem.e('nav-right')}>
            <NavItem>
              <Dropdown overlay={menu} placement="bottomRight" arrow trigger={['click']} >
                <NavLink>
                  <Avatar src={avatar} />
                </NavLink>
              </Dropdown>
            </NavItem>
          </Nav>

        </Navbar>
    );
  }
}

export default Header;
